import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import { TRoleListing } from '~types/feat/admin';

import Modal from '~components/atoms/Modal';
import RoleDetailsForm from '../RolesRoleDetailsForm';
import ActionButton from '~components/atoms/ActionButton';

import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_rolesRoleDetailsModal.module.scss';

const RolesRoleDetailsModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.admin.modals.roleDetailsModalIsOpen);
    const isLoading = useAppSelector(state => state.admin.loadings.editRoleDetails);
    const error = useAppSelector(state => state.admin.errors.editRoleDetails);
    const isEditing = useAppSelector(state => state.admin.modals.roleDetailsModalIsEditing);
    const roleDetails = useAppSelector(state => state.admin.roleDetails);
    const userAccess = useAppSelector(state => state.auth.userDetails.access);

    const hasEditAccess = userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.RBAC);

    const handleModalOnClose = () => {
        dispatch(combinedActions.adminResetEditRoleDetailsState());
        dispatch(combinedActions.adminSetRoleDetailsModalIsOpen(false));
        dispatch(combinedActions.adminSetRoleDetailsModalIsEditing(false));
    };

    const setIsEditing = (editing: boolean) => dispatch(combinedActions.adminSetRoleDetailsModalIsEditing(editing));

    const handleOnSubmit = (data: TRoleListing) => {
        if (!isLoading) {
            const {
                roleId,
                roleName,
                access,
                status,
                allBranchAccess,
            } = data;

            dispatch(combinedActions.adminEditRoleDetailsAttempt({
                roleId,
                roleName,
                access,
                status,
                allBranchAccess,
            }));
        }
    };

    return (
        <Modal
            title='Role Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {hasEditAccess
                && (
                    <ActionButton
                        label={isEditing ? 'Disable editing' : 'Enable editing'}
                        onClick={() => setIsEditing(!isEditing)}
                        className={Styles['action-button']}
                    />
                )
            }

            <RoleDetailsForm
                submitButtonLabel='Update Role'
                actionButtonClassName={Styles['form-action-button-disabled']}
                onSubmit={handleOnSubmit}
                error={error}
                isEditing={isEditing}
                inputIsDisabled={!isEditing}
                actionButtonIsDisabled={!isEditing}
                actionButtonIsLoading={isLoading}
                initialRoleDetails={roleDetails}
            />
        </Modal>
    );
};

export default RolesRoleDetailsModal;
